<mat-card data-at-installations-migration-customer-ids-modal>
  <mat-card-title data-at-installations-migration-modal-header>{{
    '+INSTALLATIONS_MIGRATION.HEADER' | translate
  }}</mat-card-title>
  <mat-card-content class="flex flex-col gap-[4px]">
    <form [formGroup]="formGroup" [ngClass]="{ 'form-invalid': formGroup.hasError('sameValues') }">
      <div class="input-fields-wrapper">
        <mat-form-field mat-input-height-large-label class="input-field">
          <mat-label>{{ '+MIGRATION.INPUT.CUSTOMER_NUMBER' | translate }}</mat-label>
          <input
            data-at-installations-migration-input-customer-number
            matInput
            [errorStateMatcher]="matcher"
            [formControl]="formGroup.controls.customerNumber"
            gtm="onTextField"
            gtmId="customer-number"
            gtmAction="Customer number"
            gtmCategory="migrateInstallation"
            [gtmOn]="['change', 'focus', 'blur']"
            fieldTextContentTooltip
          />
          <mat-error
            data-at-installations-migration-validation-error-customer-number
            *ngIf="formGroup.controls.customerNumber.hasError('required')"
          >
            {{ '+MIGRATION.VALIDATOR_ERROR.REQUIRED' | translate }}
          </mat-error>
          <mat-error
            data-at-installations-migration-validation-error-customer-number-length
            *ngIf="formGroup.controls.customerNumber.hasError('length')"
          >
            {{ '+MIGRATION.VALIDATOR_ERROR.CUSTOMER_NUMBER_LENGTH' | translate }}
          </mat-error>
          <mat-error
            data-at-installations-migration-validation-error-customer-number-pattern
            *ngIf="formGroup.controls.customerNumber.hasError('pattern')"
          >
            {{ '+MIGRATION.VALIDATOR_ERROR.CUSTOMER_NUMBER_PATTERN' | translate }}
          </mat-error>
          <mat-error
            data-at-installations-migration-validation-error-new-customer-number-not-correct
            *ngIf="formGroup.controls.customerNumber.hasError('notCorrect')"
          >
            {{ '+MIGRATION.VALIDATOR_ERROR.CUSTOMER_NUMBER_IS_NOT_CORRECT' | translate }}
          </mat-error>
        </mat-form-field>

        <mat-form-field mat-input-height-large-label class="input-field">
          <mat-label>{{ '+MIGRATION.INPUT.CUSTOMER_NUMBER_NEW' | translate }}</mat-label>
          <input
            data-at-installations-migration-input-new-customer-number
            matInput
            [errorStateMatcher]="matcher"
            [formControl]="formGroup.controls.newCustomerNumber"
            gtm="onTextField"
            gtmId="new-customer-number"
            gtmAction="New customer number"
            gtmCategory="migrateInstallation"
            [gtmOn]="['change', 'focus', 'blur']"
            fieldTextContentTooltip
          />
          <mat-error
            data-at-installations-migration-validation-error-new-customer-number
            *ngIf="formGroup.controls.newCustomerNumber.hasError('required')"
          >
            {{ '+MIGRATION.VALIDATOR_ERROR.REQUIRED' | translate }}
          </mat-error>
          <mat-error
            data-at-installations-migration-validation-error-new-customer-number-length
            *ngIf="formGroup.controls.newCustomerNumber.hasError('length')"
          >
            {{ '+MIGRATION.VALIDATOR_ERROR.CUSTOMER_NUMBER_LENGTH' | translate }}
          </mat-error>
          <mat-error
            data-at-installations-migration-validation-error-new-customer-number-pattern
            *ngIf="formGroup.controls.newCustomerNumber.hasError('pattern')"
          >
            {{ '+MIGRATION.VALIDATOR_ERROR.CUSTOMER_NUMBER_PATTERN' | translate }}
          </mat-error>
          <mat-error
            data-at-installations-migration-validation-error-new-customer-number-not-correct
            *ngIf="formGroup.controls.newCustomerNumber.hasError('notCorrect')"
          >
            {{ '+MIGRATION.VALIDATOR_ERROR.CUSTOMER_NUMBER_IS_NOT_CORRECT' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
      <mat-error
        data-at-installations-migration-validation-error-customer-numbers-equal
        *ngIf="formGroup.hasError('sameValues')"
      >
        {{ '+MIGRATION.VALIDATOR_ERROR.CUSTOMER_NUMBERS_ARE_EQUAL' | translate }}
      </mat-error>
    </form>

    <div data-at-installations-migration-modal-description class="migration__description">
      {{ '+INSTALLATIONS_MIGRATION.ENTER_CUSTOMER_IDS' | translate }}
    </div>
  </mat-card-content>
  <mat-card-actions class="mat-card-actions">
    <div class="flex flex-row lt-md:flex-col gap-[8px] justify-end items-center">
      <button
        data-at-installations-migration-btn-cancel
        mat-button
        color="primary"
        (click)="onClose()"
        gtm="onCancel"
        gtmAction="Migrating installations"
        gtmCategory="migrateInstallation"
      >
        {{ 'GENERAL.BUTTON.CANCEL' | translate }}
      </button>
      <button
        data-at-installations-migration-btn-search-for-installations
        mat-raised-button
        color="primary"
        [disabled]="!formGroup.valid"
        (click)="onSearchForInstallations()"
        gtm="onNextStep"
        gtmAction="Search for installations"
        gtmCategory="migrateInstallation"
      >
        {{ '+INSTALLATIONS_MIGRATION.BTN.SEARCH_FOR_INSTALLATIONS' | translate }}
      </button>
    </div>
  </mat-card-actions>
</mat-card>
